<template>
    <div>

        <form @submit.prevent="onHandleStore" data-vv-scope="roles">
            <b-row>

                <b-col md="12">
                    <b-form-group>
                        <label>Nombre</label>
                        <b-form-input v-model="rol.name" placeholder="Ingrese el nombre del rol" name="name"
                            data-vv-as=" " v-validate="'required'"></b-form-input>
                        <div class="text-danger span-error small" v-text="errors.first('roles.name')" />
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-form-group>
                        <label class="w-100">Descripción</label>
                        <b-form-input v-model="rol.description" placeholder="Ingrese la descripción del rol"
                            name="description" data-vv-as=" " v-validate="''"></b-form-input>
                        <div class="text-danger span-error small" v-text="errors.first('roles.description')" />
                    </b-form-group>
                </b-col>

            </b-row>
        </form>

        <div class="d-flex justify-content-end align-items-center mt-4">
            <b-button v-if="modal" type="reset" @click="onClose"> <i class="fa fa-reply mr-1"></i>Cancelar</b-button>
            <b-button class="ml-2" type="submit" variant="primary" @click="onHandleSave"><i
                    class="fa fa-save mr-1"></i>Guardar</b-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
export default {
    name: 'RolesForm',
    props: {
        modal: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState('rolesWorker', [
            'rol',
        ]),
    },
    methods: {
        ...mapMutations('rolesWorker', [
            'setRolDefault',
        ]),

        ...mapActions('rolesWorker', [
            'storeWorkRol',
            'listWorkRoles',
            'updateWorkRol',
        ]),

        onClose() {
            this.setRolDefault();
            if (this.modal) {
                this.$bvModal.hide('modal-roles');
            }
        },

        async onHandleSave() {
            const result = await this.$validator.validateAll('roles');
            if (result) {
                const action = this.rol.id ? this.updateWorkRol : this.storeWorkRol;
                const res = await action({ rol: this.rol, company_id: this.$route.params.id });
                if (res) {
                    await this.getAndClose();
                }
            }
        },

        async getAndClose() {
            this.onClose();
            await this.listWorkRoles({ company_id: this.$route.params.id });
        },
    }
}

</script>
